/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import vuetify from './vuetify'
import InfiniteLoading from 'vue-infinite-loading';
import router from './router'
import VueMoment from 'vue-moment';
import requests from './requests';
import VueSimpleAlert from 'vue-simple-alert';
import "leaflet/dist/leaflet.css";
const moment = require('moment');
require('moment/locale/it')

import Vue from 'vue';

require('./bootstrap');


window.Vue = require('vue').default;

window.Vue.use(VueMoment, {
    moment
});
window.Vue.use(VueSimpleAlert);
window.Vue.use(InfiniteLoading, { /* options */ });
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
//Vue.moment().locale(it);
const App = require('./App.vue').default;
(async () => {

    const me = await requests.getMe();
    window.currentUser = me.data;
    const app = new Vue({
        router,
        vuetify,
        render: h => h(App),
        el: '#app',
    });

})();


//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

